import { Fragment, memo } from 'react';
import Accountholder from '../shared/accountholder-historical';
import Applicant from '../shared/applicant';
import Payment from '../shared/fragment-payment';

interface LeverFormProps {
  disabled?: boolean;
}

const LeverFormComponent = ({ disabled }: LeverFormProps): React.ReactElement => {
  return (
    <Fragment>
      <Payment />
      <Applicant disabled={disabled} />
      <Accountholder />
    </Fragment>
  );
};

LeverFormComponent.displayName = 'Lever Form component';

const LeverForm = memo(LeverFormComponent);

export default LeverForm;
